/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceQueryCategory extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ResourceQueryCategory");
    }

    getFixupPrototypeFunction() { return ResourceQueryCategory.fixupPrototype; }

    static newInstance(model: Partial<ResourceQueryCategory>): ResourceQueryCategory {
        let obj = Object.assign(new ResourceQueryCategory(), model);
        ResourceQueryCategory.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceQueryCategory>): ResourceQueryCategory {
        if (!model) return null;
        return ResourceQueryCategory.newInstance(<ResourceQueryCategory> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceQueryCategory) {
        if (!obj) return;

        models.ResourceQueryCategory.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceQueryCategory): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ResourceQueryCategory.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Categories for the resources
     */
    categories: Array<string>;

}
